import React from "react";
import { Link } from "react-router-dom";
import ReactPlayer from "react-player";
import Helper from "../../Helper/helper";
import ContentLoader from "../../Static/contentLoader";

import api from "../../../Environment";

import io from "socket.io-client";

import { apiConstants } from "../../Constant/constants";
import {
  resolvePlaybackExperience,
  getPrimaryIntroLayer,
} from "../../Helper/playbackExperience";
import { sanitizePlaybackUrl } from "../../../video-player/production/buildHostPlayerConfig";
import { shouldMuteIntroForAutoplay } from "../../../video-player/production/autoplayPolicy";

const socket = apiConstants.socketUrl ? io(apiConstants.socketUrl) : "";

let userId = localStorage.getItem("userId");

let accessToken = localStorage.getItem("accessToken");

let subProfId = localStorage.getItem("active_profile_id");

class VideoComponent extends Helper {
  state = {
    loadingFirst: true,
    videoDetailsFirst: null,
    onPlayStarted: false,
    videoList: {},
    videoData: null,
    videoId: 0,
    socket: false,
    query: "",
    onSeekPlay: true,
    socketConnection: true,
    videoDuration: 0,
    socketConnected: false,
    historyRecorded: false,
    playingCinematicIntro: false,
    introSkipVisible: false,
    cinematicIntroChecked: false,
    seamlessMainAutoplay: false,
    /** Cold-load intro must be muted for browser autoplay policy */
    introAutoplayMuted: false,
    playerMuted: false,
  };

  componentDidMount() {
    if (this.props.location.state) {
      const muteIntro = shouldMuteIntroForAutoplay();
      this.setState({ loadingFirst: false, introAutoplayMuted: muteIntro });
      const isTrailer = this.props.location.state.videoFrom === "trailer";
      const pe = resolvePlaybackExperience(
        this.props.location.state.videoDetailsFirst,
        { isTrailer }
      );
      const layer = getPrimaryIntroLayer(pe);
      if (layer && layer.url) {
        this.setState({
          playingCinematicIntro: true,
          cinematicIntroChecked: true,
          seamlessMainAutoplay: true,
        });
      } else {
        this.setState({ cinematicIntroChecked: true });
      }
    } else {
      window.location = "/home";
    }
  }

  timer = async () => {
    if (this.state.onPlayStarted) {
      await this.socketConnectionfun(userId, accessToken);
    }
  };

  componentWillUnmount() {
    // use intervalId from the state to clear the interval
    clearInterval(this.state.intervalId);
  }

  /**
   * End cinematic intro and continue straight into the selected video.
   */
  beginMainContentPlayback = () => {
    this.setState({
      playingCinematicIntro: false,
      introSkipVisible: false,
      seamlessMainAutoplay: true,
    });
  };

  ensureMainAutoplay = () => {
    if (this.state.playingCinematicIntro || !this.state.seamlessMainAutoplay) {
      return;
    }
    if (this.player && typeof this.player.getInternalPlayer === "function") {
      const media = this.player.getInternalPlayer();
      if (media && typeof media.play === "function") {
        const playPromise = media.play();
        if (playPromise && typeof playPromise.catch === "function") {
          playPromise.catch(() => {
            // Same autoplay policy as intro — mute and retry after cold load
            try {
              if ("muted" in media) {
                media.muted = true;
              }
              if (typeof media.setVolume === "function") {
                media.setVolume(0);
              }
            } catch (e) {
              /* ignore */
            }
            this.setState({ playerMuted: true });
            const retry = media.play();
            if (retry && typeof retry.catch === "function") {
              retry.catch(() => {});
            }
          });
        }
      }
    }
  };

  ensureIntroAutoplay = () => {
    if (!this.state.playingCinematicIntro) {
      return;
    }
    if (this.player && typeof this.player.getInternalPlayer === "function") {
      const media = this.player.getInternalPlayer();
      if (media && typeof media.play === "function") {
        const playPromise = media.play();
        if (playPromise && typeof playPromise.catch === "function") {
          playPromise.catch(() => {
            try {
              if ("muted" in media) {
                media.muted = true;
              }
              if (typeof media.setVolume === "function") {
                media.setVolume(0);
              }
            } catch (e) {
              /* ignore */
            }
            this.setState({ introAutoplayMuted: true, playerMuted: true });
            const retry = media.play();
            if (retry && typeof retry.catch === "function") {
              retry.catch(() => {});
            }
          });
        }
      }
    }
  };

  onCompleteVideo = () => {
    if (this.state.playingCinematicIntro) {
      this.beginMainContentPlayback();
      return;
    }
    this.addHistory(this.props.location.state.videoDetailsFirst.admin_video_id);
    this.setState({ onPlayStarted: false, socketConnection: false });
    if (this.state.socketConnected) {
      socket.emit("disconnect");
    }
  };

  skipCinematicIntro = (event) => {
    if (event) {
      event.preventDefault();
    }
    this.beginMainContentPlayback();
  };

  onIntroTimeUpdate = (event) => {
    const current = event.target.currentTime || 0;
    const isTrailer = this.props.location.state.videoFrom === "trailer";
    const pe = resolvePlaybackExperience(
      this.props.location.state.videoDetailsFirst,
      { isTrailer }
    );
    const layer = getPrimaryIntroLayer(pe);
    if (layer && layer.skip_after_seconds && current >= layer.skip_after_seconds) {
      this.setState({ introSkipVisible: true });
    }
  };

  onVideoPlay = async () => {
    if (this.state.playingCinematicIntro || this.state.onPlayStarted) {
      return;
    }

    let intervalId = setInterval(this.timer, 3000);

    this.setState({ intervalId: intervalId });

    this.setState({ onPlayStarted: true, socketConnection: true });

    let inputData = {
      admin_video_id: this.props.location.state.videoDetailsFirst
        .admin_video_id,
    };
    var details = await this.onlySingleVideoFirst(inputData);

    this.redirectStatus(details);

    // Record history / view once per playback session (backend also cooldown-dedupes).
    if (!this.state.historyRecorded) {
      this.addHistory(this.props.location.state.videoDetailsFirst.admin_video_id);
      this.setState({ historyRecorded: true });
    }

    const seekTime =
      (details && details.seek_time_in_seconds) ||
      (this.state.videoDetailsFirst &&
        this.state.videoDetailsFirst.seek_time_in_seconds) ||
      0;

    if (this.state.onSeekPlay && seekTime > 0 && this.player) {
      this.player.seekTo(parseFloat(seekTime));
    }

    this.setState({ onSeekPlay: false });
  };

  addHistory = (admin_video_id) => {
    api
      .postMethod("addHistory", { admin_video_id: admin_video_id })
      .then((response) => {
        if (response.data.success === true) {
        } else {
        }
      })
      .catch(function(error) {});
  };

  socketConnectionfun = (userId, accessToken) => {
    if (apiConstants.socketUrl) {
      let videoId = this.props.location.state.videoDetailsFirst.admin_video_id;

      socket.on("connect", function() {
        let query = `user_id=` + userId + `&video_id=` + videoId;
      });

      socket.on("connected", function() {
        console.log("Connected");
        this.setState({ socketConnected: true });
      });

      socket.on("disconnect", function() {
        console.log("disconnect");
        this.setState({ socketConnected: false });
      });

      console.log(this.state.videoDuration);

      let videoData = [
        {
          sub_profile_id: subProfId,
          admin_video_id: videoId,
          id: userId,
          token: accessToken,
          duration: this.state.videoDuration,
        },
      ];

      socket.emit("save_continue_watching_video", videoData[0]);
    }
  };

  onPauseVideo = async () => {
    console.log("onPause");
    if (this.state.socketConnected) {
      socket.emit("disconnect");
    }
    clearInterval(this.state.intervalId);
  };

  onVideoTimeUpdate = (duration) => {
    let video_duration = duration.target.currentTime;

    console.log("vido"+video_duration);

    this.setState({ videoDuration: video_duration });

    // let sec = parseInt(video_duration % 60);
    // let min = parseInt((video_duration / 60) % 60);
    // let hours = parseInt(video_duration / 3600);

    // if (hours > 1) {
    //   this.setState({ videoDuration: hours + ":" + min + ":" + sec });
    // } else {
    //   this.setState({ videoDuration: min + ":" + sec });
    // }
  };

  ref = (player) => {
    this.player = player;
  };

  render() {
    const pageType = "videoPage";
    if (this.state.onPlayStarted) {
      const returnToVideo = this.renderRedirectPage(
        this.state.videoDetailsFirst,
        pageType
      );

      if (returnToVideo != null) {
        return returnToVideo;
      }
    }
    const { loadingFirst } = this.state;
    let mainVideo, videoTitle, videoType, subTitle;

    if (loadingFirst) {
      return <ContentLoader />;
    } else {
      // Check the whether we need to play the trailer or main video

      if (this.props.location.state.videoFrom != undefined) {
        subTitle = this.props.location.state.videoDetailsFirst
          .video_subtitle_vtt;

        if (this.props.location.state.videoFrom == "trailer") {
          mainVideo = this.props.location.state.videoDetailsFirst.resolutions
            .original;
          subTitle = this.props.location.state.videoDetailsFirst
            .trailer_subtitle;
        } else {
          mainVideo = this.props.location.state.videoDetailsFirst.resolutions
            .original;
        }

        videoTitle = this.props.location.state.videoDetailsFirst.name;

        videoType = this.props.location.state.videoDetailsFirst.video_type;
      } else {
        mainVideo = this.props.location.state.videoDetailsFirst.main_video;

        subTitle = this.props.location.state.videoDetailsFirst
          .video_subtitle_vtt;

        videoTitle = this.props.location.state.videoDetailsFirst.title;

        videoType = this.props.location.state.videoDetailsFirst.video_type;
      }

      const isTrailer = this.props.location.state.videoFrom === "trailer";
      const pe = resolvePlaybackExperience(
        this.props.location.state.videoDetailsFirst,
        { isTrailer }
      );
      const introLayer = getPrimaryIntroLayer(pe);
      const showingIntro =
        this.state.playingCinematicIntro && introLayer && introLayer.url;
      const playerUrl = showingIntro
        ? sanitizePlaybackUrl(introLayer.url)
        : sanitizePlaybackUrl(mainVideo);
      // After cinematic intro, skip light/poster mode so main content autoplays.
      const lightMode =
        showingIntro || this.state.seamlessMainAutoplay
          ? false
          : this.props.location.state.videoDetailsFirst.default_image;

      return (
        <div>
          <div className="single-video">
            {showingIntro && this.state.introSkipVisible ? (
              <div className="skip-intro-sec" id="skip-intro-sec">
                <button
                  type="button"
                  className="skip-intro-btn"
                  onClick={this.skipCinematicIntro}
                  aria-label="Skip intro"
                >
                  Skip Intro
                </button>
              </div>
            ) : null}
            <ReactPlayer
              ref={this.ref}
              url={playerUrl}
              controls={true}
              width="100%"
              height="100vh"
              playing={true}
              muted={
                !!(
                  this.state.playerMuted ||
                  (showingIntro && this.state.introAutoplayMuted)
                )
              }
              onReady={() => {
                this.ensureIntroAutoplay();
                this.ensureMainAutoplay();
              }}
              onStart={showingIntro ? undefined : this.onLoad}
              onPause={showingIntro ? undefined : this.onPauseVideo}
              onPlay={
                showingIntro || isTrailer ? undefined : this.onVideoPlay
              }
              onEnded={this.onCompleteVideo}
              onTimeUpdate={
                showingIntro ? undefined : this.onVideoTimeUpdate.bind(this)
              }
              onProgress={
                showingIntro
                  ? (state) => {
                      if (
                        introLayer.skip_after_seconds &&
                        state.playedSeconds >= introLayer.skip_after_seconds
                      ) {
                        this.setState({ introSkipVisible: true });
                      }
                    }
                  : undefined
              }
              light={lightMode}
              config={{
                file: {
                  tracks: showingIntro
                    ? []
                    : [
                        {
                          kind: "subtitles",
                          src: subTitle,
                          srcLang: "en",
                          default: true,
                        },
                      ],
                  attributes: {
                    controlsList: "nodownload",
                    playsInline: true,
                  },
                },
                youtube: {
                  playerVars: {
                    playsinline: 1,
                    autoplay: 1,
                    mute:
                      this.state.playerMuted ||
                      (showingIntro && this.state.introAutoplayMuted)
                        ? 1
                        : 0,
                  },
                },
                vimeo: {
                  playerOptions: {
                    playsinline: true,
                    autopause: false,
                    muted: !!(
                      this.state.playerMuted ||
                      (showingIntro && this.state.introAutoplayMuted)
                    ),
                  },
                },
              }}
            />
            <div className="back-arrowsec">
              <Link to="/home">
                <img
                  src={window.location.origin + "/assets/img/left-arrow.png"}
                  alt="arrow"
                />
                {videoType == 2 ? (
                  ""
                ) : (
                  <span className="txt-overflow capitalize ml-3">
                    {videoTitle}
                  </span>
                )}
              </Link>
            </div>
          </div>
        </div>
      );
    }
  }
}

export default VideoComponent;
